import { format } from "date-fns/esm";
import React from "react";
import ReactQuill from "react-quill";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "shards-react";
import { getLatestFileUrl } from "../../../util/getLatestFileUrl";

const EmailDetails = ({ email, closeModal }) => {
  const modules = {
    toolbar: false,
  };
  return (
    <Modal
      className="col-md-8 col-lg-8"
      open={true}
      toggle={closeModal}
      modalClassName="modal"
      fade={true}
      role="dialog"
    >
      <ModalHeader className="bg-primary1">Email Details</ModalHeader>
      <ModalBody>
        <Row>
          <Col md="6">
            <strong>Sender: </strong> {(email && email.value.sender) || ""}
          </Col>
          <Col md="6">
            <strong>ID: </strong> {(email && email.value.sender_id) || ""}
          </Col>
          <Col md="6">
            <strong>Date: </strong>
            {(email.value.date &&
              format(new Date(email.value.date), "dd-MM-yyyy kk:mm")) ||
              ""}
          </Col>
          <Col md="6">
            <strong>To: </strong> {(email && email.value.to) || ""}
          </Col>
          <Col md="6">
            <strong>CC: </strong> {(email && email.value.cc) || ""}
          </Col>
          {email.value.files && email.value.files.length > 0 ? (
            <Col>
              <strong>Attachments</strong>
              {email.value.files.map((file, index) => {
                return (
                  <div key={file.fileName}>
                    <a
                      onClick={() =>
                        getLatestFileUrl(email.value.id, file, "documents")
                      }
                      className="text-primary custom-link"
                    >
                      {file.fileName}
                    </a>
                  </div>
                );
              })}
            </Col>
          ) : (
            ""
          )}
        </Row>
        <Row>
          <Col>
            <strong>Message: </strong>
            <ReactQuill
              modules={modules}
              readOnly={true}
              defaultValue={email.value.html}
              toolbar={false}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="home-buttons d-flex w-100 justify-content-between p-2">
        <Button theme="danger" onClick={() => closeModal()}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EmailDetails;
